@if (selected(); as banner) {
    <div class="super-banner">
        <button mat-icon-button
                class="super-banner-toggle"
                [class.hidden-position]="hidden()"
                (click)="toggleBanner()">
            <mat-icon>{{ hidden() ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>

        <div class="banner-wrapper"
             data-track-content
             data-content-name="Sticky banner"
             [@slideUpDown]="hidden() ? 'hidden' : 'visible'">

            <a [href]="banner.link || null"
               [target]="banner.link ? banner.target : null"
               [class.no-link]="!banner.link"
               data-content-target>

                <img [src]="CDN + '/marketing-management/' + banner.image"
                     [alt]="banner.title"
                     data-content-piece
                     class="super-banner-image"
                     loading="eager">
            </a>
        </div>
    </div>
}